import {
  HyperlinkStaticCellRenderer,
  IGridHyperlink,
} from '../../../utils/custom-renderer/hyperlink-cell-renderer';
import { getNumericPattern } from '../../../utils/formatting';

export enum COLUMN_FIELDS {
  TICKER = 'TICKER',
  UNIQUE_ID = 'UNIQUE_ID',
  FIXED_PRICE = 'FIXED_PRICE',
  OFFERED_CAPACITY = 'OFFERED_CAPACITY',
}

export function VPPA_COLUMNS() {
  return [
    {
      field: COLUMN_FIELDS.TICKER,
      headerName: 'Ticker',
      suppressMenu: true,
      flex: 1,
    },

    {
      field: COLUMN_FIELDS.UNIQUE_ID,
      headerName: 'Unique ID',
      suppressMenu: true,
      flex: 1,
      valueGetter: (props) => {
        return JSON.stringify({
          NAME: props.data.UNIQUE_ID,
          PROJECT_ID: props.data.PROJECT_ID,
        });
      },
      cellRenderer: HyperlinkStaticCellRenderer,
      cellRendererParams: (params) => {
        const obj = JSON.parse(params.value);
        const hyperlinkParams: IGridHyperlink = {
          value: obj.NAME,
          id: obj.PROJECT_ID,
          vppaId: params.data.VPPA_ID,
          iconList: [],
        };
        return hyperlinkParams;
      },
    },
    {
      field: COLUMN_FIELDS.FIXED_PRICE,
      headerName: 'Fixed Price',
      valueFormatter: (params) => getNumericPattern(params.data.FIXED_PRICE, null, '$'),
      suppressMenu: true,
      flex: 1,
    },
    {
      field: COLUMN_FIELDS.OFFERED_CAPACITY,
      headerName: 'Capacity (MW)',
      suppressMenu: true,
      flex: 1,
    },
  ];
}
